<template>
<div class="c-container__wrap">
  <bg></bg>
  <main>
    <router-view></router-view>
  </main>
  <common-footer></common-footer>
  <common-header></common-header>
  <scroll-down></scroll-down>
  <modal></modal>
  <loading></loading>
</div>
</template>

<script>
import Loading from '@/_components/Loading';
import Bg from '@/_components/Bg';
import Modal from '@/_components/Modal';
import ScrollDown from '@/_components/ScrollDown';
import CommonHeader from '@/_components/CommonHeader';
import CommonFooter from '@/_components/CommonFooter';

import { gsap, Power3 } from 'gsap/all';
import { Observer } from 'gsap/Observer';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(Observer, ScrollToPlugin);

export default {
  components: {
    Loading,
    Bg,
    ScrollDown,
    Modal,
    CommonHeader,
    CommonFooter
  },
  data() {
    return {
    }
  },
  watch: {
    $route(to, from) {
      window.gPG.rootHTML.classList.remove(`is-page--${from.name}`);
      window.gPG.rootHTML.classList.add(`is-page--${to.name}`);
    },
  },
  mounted() {
  },
  methods: {
  }
}
</script>